export default __webpack_public_path__ + "static/media/Mockup.474a673b.png";